export const HERO_IMAGE =
  "/images/2jjfpubj_F74BB30F-29FD-492B-925C-88CE92FD2BE3.png";

// Real venue photography — atmosphere, crowds, performers.
export const VENUE_PHOTOS = {
  crowdComedy: "/images/crowd-comedy-stage.webp",
  crowdPacked: "/images/crowd-packed.webp",
  comedyPerformers: "/images/comedy-performers.webp",
  karaokeDuets: "/images/karaoke-duets.webp",
  karaokeSingers: "/images/karaoke-singers.webp",
};

// 4 experience pillars for the homepage. Each card uses a real TNT photo.
export const EXPERIENCES = [
  {
    title: "Comedy Nights",
    blurb: "Packed rooms, live stand-up & open mic every Tuesday.",
    img: "/images/comedy-performers.webp",
    accent: "Every Tuesday",
  },
  {
    title: "Karaoke",
    blurb: "Grab the mic Wednesdays & Sundays under the neon TNT sign.",
    img: "/images/karaoke-duets.webp",
    accent: "Wed & Sun",
  },
  {
    title: "Live Music",
    blurb: "Touring bands, jam nights and weekend live entertainment.",
    img: "/images/mkt5em3p_IMG_6623.jpeg",
    accent: "Thu • Fri • Sat",
  },
  {
    title: "Great Food & Drinks",
    blurb: "Wings, momos, butter chicken & a stacked tap list.",
    img: "/images/onzf443b_IMG_6581.jpeg",
    accent: "Open till 2 AM",
  },
];

// 3 signature dishes shown on the homepage food preview.
export const SIGNATURE_DISHES = [
  {
    name: "Wings",
    blurb: "Hand-tossed in your favourite flavour.",
    img: "/images/onzf443b_IMG_6581.jpeg",
  },
  {
    name: "Butter Chicken",
    blurb: "Rich, creamy & served with rice or naan.",
    img: "/images/vnv5ypan_IMG_6882.jpeg",
  },
  {
    name: "Himalayan Momos",
    blurb: "Hand-folded dumplings, house sauce.",
    img: "/images/osn5uim0_IMG_6876.jpeg",
  },
];

// Real Taps & Tunes special guest photos. Premium "headliner wall" layout.
export const FEATURED_GUESTS = [
  {
    img: "/images/5ktsp9pg_IMG_6853.jpeg",
    name: "Kenny vs. Spenny",
    type: "Comedy Special",
  },
  {
    img: "/images/mkt5em3p_IMG_6623.jpeg",
    name: "Ben Bankas",
    type: "Comedian",
  },
  {
    img: "/images/p3ks3ucr_IMG_6620.jpeg",
    name: "Randy from Trailer Park Boys",
    type: "Special Event",
  },
  {
    img: "/images/5yxn4ra2_PHOTO-2025-08-15-21-56-52.jpeg",
    name: "Asians In One Cup",
    type: "Comedy Duo",
  },
];

export const CONTACT = {
  address: "18 Huron St, Collingwood, ON",
  phone: "(705) 445-1786",
  phoneTel: "+17054451786",
  linktree: "https://linktr.ee/tapsandtunesbarandgrill",
  mapsUrl: "https://www.google.com/maps?q=18+Huron+St,+Collingwood,+ON",
};

export const WEEKLY_EVENTS = [
  {
    day: "Every Tuesday",
    title: "Comedy Open Mic",
    time: "8:30 PM",
    desc: "",
    img: "/images/tuesday-comedy.webp",
  },
  {
    day: "Every Wednesday",
    title: "Karaoke Night",
    time: "7:00 PM",
    desc: "Grab the mic under the neon TNT sign",
    img: "/images/karaoke-duets.webp",
  },
  {
    day: "Every Thursday",
    title: "Open Mic Jam Night",
    time: "8:30 PM",
    desc: "Musicians, songwriters & jammers welcome",
    img: "/images/thursday-openmic.webp",
  },
  {
    day: "Every Friday",
    title: "Live Entertainment",
    time: "",
    desc: "Touring bands & weekend headliners",
    img: "/images/friday-live.webp",
  },
  {
    day: "Every Saturday",
    title: "Live Entertainment",
    time: "",
    desc: "Bands, DJs & late-night vibes",
    img: "/images/saturday-live.webp",
  },
  {
    day: "Every Sunday",
    title: "Industry Night & Karaoke",
    time: "7:00 PM",
    desc: "Service industry hangs & sing-alongs",
    img: "/images/karaoke-singers.webp",
  },
];

export const EVENT_TYPES = [
  "Birthday Party",
  "Bachelor & Bachelorette Party",
  "Fundraiser",
  "Corporate Event",
  "Private Celebration",
];

// Photo URLs for real Taps & Tunes dishes. Add a `photo` field on any item
// that has a real photo; items without `photo` simply render without one.
const A = "/images";

export const MENU_CATEGORIES = [
  {
    id: "appetizers",
    title: "Appetizers",
    subtitle: "Shareable starters & crispy classics",
    items: [
      { name: "Samosas", price: 8, desc: "Crispy handmade pastries filled with seasoned potatoes and aromatic spices. Served with dipping sauce." },
      { name: "Pickle Spears", price: 16, desc: "Crispy beer-battered pickle spears served golden brown with a side dip.", photo: `${A}/fzd61ynt_IMG_6875.jpeg` },
      { name: "Spanakopita", price: 16, desc: "Flaky phyllo pastry stuffed with spinach and feta cheese.", photo: `${A}/mh9nom5m_IMG_6880.jpeg` },
      { name: "Crispy Trio Medley", price: 24, desc: "A shareable platter featuring TNT Fries, Sweet Potato Fries, Onion Rings and three dipping sauces.", photo: `${A}/d16zl0yb_IMG_6887.jpeg` },
      { name: "Beer Battered Shrimp", price: 18, desc: "Golden crispy shrimp served with house dipping sauce.", photo: `${A}/tainrm85_IMG_6884.jpeg` },
      { name: "Calamari", price: 17, desc: "Lightly breaded calamari, fried until crispy and served with a side dip.", photo: `${A}/cpmxyfsc_IMG_6889.jpeg` },
      { name: "Onion Rings", price: 14, desc: "Beer-battered onion rings fried to perfection." },
      { name: "Moroccan Cigars", price: 16, desc: "Ground beef wrapped in crispy phyllo pastry with warm Moroccan spices.", photo: `${A}/cnwjl0n0_IMG_6883.jpeg` },
      { name: "Cauliflower Bites", price: 15, desc: "Crispy cauliflower bites served with your choice of dipping sauce." },
    ],
  },
  {
    id: "wings",
    title: "Wings & Chicken",
    subtitle: "Hand-tossed in your favourite flavour",
    heroPhoto: `${A}/onzf443b_IMG_6581.jpeg`,
    items: [
      { name: "Wings", price: 17, desc: "One pound of wings served with celery, carrots and ranch or blue cheese dressing." },
      { name: "Chicken Bites", price: 16, desc: "Boneless chicken bites tossed in your choice of flavour." },
    ],
  },
  {
    id: "momos",
    title: "Momos",
    subtitle: "Hand-folded Himalayan dumplings",
    heroPhoto: `${A}/osn5uim0_IMG_6876.jpeg`,
    items: [
      { name: "Himalayan Momos", price: 17, desc: "Traditional steamed dumplings filled with vegetables or chicken and served with house sauce." },
      { name: "Mountain Momos", price: 18, desc: "Steamed and lightly fried dumplings filled with vegetables or chicken." },
      { name: "Momos in Sauce", price: 19, desc: "Momos tossed in your choice of Chili Sauce, Butter Chicken Sauce or Creamy White Sauce." },
    ],
  },
  {
    id: "tnt-favorites",
    title: "TNT Favourites",
    subtitle: "Hearty mains the locals come back for",
    items: [
      { name: "Butter Chicken", price: 22, desc: "Tender chicken simmered in a rich and creamy butter chicken sauce. Served with rice or naan.", photo: `${A}/vnv5ypan_IMG_6882.jpeg` },
      { name: "Classic Poutine", price: 15, desc: "Fresh-cut fries topped with cheese curds and savoury gravy." },
      { name: "Butter Chicken Poutine", price: 18, desc: "Classic poutine topped with butter chicken sauce and tender chicken pieces." },
      { name: "Chicken Tenders", price: 18, desc: "Breaded chicken tenders served with fries and plum sauce." },
      { name: "Fish & Chips", price: 17, desc: "Beer-battered haddock served with fries and tartar sauce." },
      { name: "Sweet Potato Fries", price: 9, desc: "Crispy sweet potato fries served with dipping sauce." },
      { name: "TNT Fries", price: 8, desc: "Fresh-cut fries seasoned and cooked to perfection." },
    ],
  },
  {
    id: "pasta",
    title: "Pasta",
    subtitle: "Comfort plates made to order",
    items: [
      { name: "Penne Mediterranean", price: 19, desc: "Penne pasta tossed with peppers, onions, olive oil and Mediterranean flavours.", photo: `${A}/fbf5yxns_IMG_6879.jpeg` },
      { name: "Penne Alfredo", price: 18, desc: "Penne pasta in a rich and creamy Alfredo sauce.", photo: `${A}/bebec8fn_IMG_6886.jpeg` },
      { name: "Penne Marinara", price: 17, desc: "Penne pasta tossed in classic tomato marinara sauce.", photo: `${A}/ielbcesy_IMG_6885.jpeg` },
      { name: "Chicken Parmesan", price: 23, desc: "Breaded chicken breast topped with mozzarella and served with pasta.", photo: `${A}/lsxo950a_IMG_6877.jpeg` },
    ],
  },
  {
    id: "burgers",
    title: "Burgers",
    subtitle: "Flame-grilled, stacked tall",
    items: [
      { name: "TNT Burger", price: 22, desc: "House-made cheeseburger topped with bacon, crispy onions and served with fries and onion rings.", photo: `${A}/0bpaceps_IMG_6881.jpeg` },
      { name: "Cheeseburger", price: 18, desc: "Flame-grilled beef burger with cheddar cheese, lettuce, tomato, pickles and house sauce. Served with fries." },
    ],
  },
];

export const EVENT_POSTERS = [
  {
    title: "Comedy Open Mic",
    date: "Every Tuesday • 8 PM",
    img: "/images/xh6unmoy_546F1B74-0FE2-4732-8E2E-B370E2C12CA4.png",
  },
  {
    title: "Open Mic Jam Night",
    date: "Every Thursday • 8:30 PM",
    img: "/images/5zlj31nc_922cb08e-fd8b-4f25-bfe5-49a1d7a9ff1b.jpeg",
  },
  {
    title: "Ramen Night",
    date: "Every Friday • 6 – 8 PM",
    img: "/images/dvymf3gr_IMG_6903.jpeg",
  },
  {
    title: "Live Audience Mediumship Readings",
    date: "Saturday, June 20 • 7 – 9 PM",
    img: "/images/tyvkdyyd_IMG_6904.jpeg",
  },
];
